import React from "react";

export default function BrokerCodeOfConduct() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-semibold mb-6">Broker Code of Conduct for User</h1>

      <p className="mb-4"><strong>Last Updated:</strong> 09/02/2026</p>

      <p className="mb-4">
        This Broker Code of Conduct for User (“Code”) applies to all brokers, brokerage firms and authorised personnel who register with or access PRObroker. Compliance with this Code is a condition of continued access and subscription.
      </p>

      <p className="mb-4">
        You shall ensure that all property information and listings you supply (including any updates or comments) are truthful, accurate and not misleading in any material respect. You must disclose:
      </p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Known legal impediments, encumbrances or disputes relating to a property, where such information is known to you.</li>
        <li>Any brokerage fees, commission structures or charges payable by either party, to the extent they are known and relevant.</li>
        <li>Your relationship or interest in the property (e.g., if you are related to the owner or have a financial interest).</li>
      </ul>

      <p className="mb-4">
        You shall promptly correct or request correction of any inaccurate or outdated data that you become aware of, in accordance with the Content Takedown Policy.
      </p>

      <p className="mb-4">You shall not:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Misrepresent property size, location, price, approvals, builder reputation or any other key attribute.</li>
        <li>Falsely claim exclusivity or misstate competing offers to pressure parties.</li>
        <li>Use fake leads, fake inquiries, or spoofed identities.</li>
        <li>Misrepresent PRObroker as a guarantee of property verification or transaction success.</li>
      </ul>

      <p className="mb-4">
        You shall avoid any practice that could be considered unfair trade practice, misleading advertisement, or violation of consumer protection norms under Indian law.
      </p>

      <p className="mb-4">
        You shall conduct all dealings with property owners, buyers, tenants and other brokers in a professional, courteous and non-abusive manner.
      </p>

      <p className="mb-4">
        You shall respect privacy, confidentiality and applicable data protection norms when using property contact data sourced from PRObbroker.
      </p>

      <p className="mb-4">
        Harassment, threats, discriminatory behaviour or invasive conduct towards any person are strictly prohibited.
      </p>

      <p className="mb-4">
        We may, at our discretion, conduct reasonable audits or checks to verify accuracy and integrity of your listings or data contributions, complaints or reports received about your conduct, potential misuse of property data or violation of this Code. You agree to cooperate with such audits by providing clarifications, limited supporting documentation or logs, subject to confidentiality and applicable law.
      </p>

      <p className="mb-4">
        We may take one or more of the following actions in case of suspected or confirmed breach of this Code, serious or repeated violations, including misrepresentation leading to substantial loss or regulatory complaints, may result in permanent bans and further legal action.
      </p>
    </div>
  );
}
